import { createUseStyles } from "react-jss";
import { colors } from "../../../../../constants/colors";
import { breakpoints } from "../../../../../constants/breakpoints";

const styles = createUseStyles(theme => ({
  filters: {
    margin: "32px 0 24px 0",
    display:"flex",
    justifyContent:"space-between",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      display: "grid",
      gap: "10px",
      justifyContent: "normal"
    },
  },
  filter: {
    fontWeight: "600",
    fontSize: "14px",
    lineHeight: "20px",
    width: "fit-content",
    display: "inline-block",
  },
  filterButtons:{
    display:"flex",
    flexDirection:"row",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      display: "grid",
    },
  },
  buttonContainer:{
    display:"flex",
    justifyContent:"flex-end",
    alignItems:"flex-end",
    height: "min-content",
    alignSelf: "end",
    cursor: "not-allowed",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      display: "block",
    },
  },
  button: {
    minHeight: "40px",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      display: "flex",
      alignItems: "center",
      justifyContent :"center"
    },
  },
  filterText:{
    display:"flex",
    flexDirection:"column",
    fontWeight: "500",
    fontSize: "14px",
    lineHeight: "20px",
    color: colors.grey,
    "& p":{
      marginBottom:"6px"
    },
    "& span": {
      color: theme.filterText.filterTextColor,
      fontWeight: "500",
      fontSize: theme.filterText.filterTextSize,
      lineHeight: "20px",
    }
  },
}));

export default styles;
